import {
  useStyle 
} from "@/classify"
import {
  FormattedMessage 
} from "react-intl"

import Shimmer from "../Shimmer"
import defaultClasses from "./productSort.module.css"

const ProductSortShimmer = (props) => {
  const classes = useStyle(defaultClasses, props.classes)

  return (
    <div className={classes.root} aria-live='polite' aria-busy='true'>
      <span className={classes.label}>
        <FormattedMessage
          id={"productSort.sortByButton"}
          defaultMessage={"Sort by"}
        />
      </span>
      <Shimmer
        classes={{
          root_button: classes.sortButtonCollapsed 
        }}
        type='button'
      />
    </div>
  )
}

export default ProductSortShimmer
